// @ts-nocheck
(function () {
  "use strict";

  const root = document.querySelector("[data-shopping-receipt-root]");
  if (!root) return;
  function hideLoader() {
    root.classList.remove("is-loading");
  }

  if (!window.AccountAuth || !window.AccountHttp || !window.AccountEndpoints) {
    console.error(
      "[shopping-receipt] AccountAuth/AccountHttp/AccountEndpoints not loaded — check script order.",
    );
    hideLoader();
    return;
  }

  const { authFetch } = window.AccountHttp;
  const { TRANSACTION_RECEIPT, TRANSACTIONS } = window.AccountEndpoints;

  const FALLBACK_PAGE_SIZE = 50;
  // Self-hosted in the theme's assets/ folder (passed in by the section).
  const QRCODE_URL =
    window.ReceiptPrintAssets && window.ReceiptPrintAssets.qrcode;

  const HISTORY_PAGE_URL =
    root.getAttribute("data-history-url") || "/pages/shopping-history";

  const PLACEHOLDER_IMAGE = root.getAttribute("data-placeholder-image");

  const transactionId = new URLSearchParams(window.location.search).get("id");

  const els = {
    breadcrumbCurrent: root.querySelector(".account-breadcrumb-current"),
    transactionNumber: root.querySelector(".receipt-transaction-number"),
    copyBtn: root.querySelector("[data-receipt-copy]"),
    summaryDate: root.querySelector(".receipt-summary-date"),
    summaryTotal: root.querySelector(".receipt-summary-total"),
    summaryPayment: root.querySelector(".receipt-summary-payment"),
    storeAddress: root.querySelector(".receipt-store-address"),
    actionsCol: root.querySelector(".receipt-actions-col"),
    printLink: root.querySelector("[data-receipt-print]"),
    itemsHeading: root.querySelector(".receipt-items-heading"),
    itemsGrid: root.querySelector(".receipt-items-grid"),
    taxRows: root.querySelectorAll(".receipt-tax-row"),
    receiptTitle: root.querySelector(".receipt-title"),
  };

  // ---- helpers ---------------------------------------------------------

  function ordinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function formatDate(iso) {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return (
      ordinal(d.getDate()) +
      " " +
      d.toLocaleString("en-GB", { month: "long" }) +
      " " +
      d.getFullYear()
    );
  }

  function formatTime(iso) {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12 || 12;
    return hours + ":" + minutes + " " + ampm;
  }

  function formatMoney(amount, currency) {
    if (amount === null || amount === undefined) return "";
    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: currency || "GBP",
        signDisplay: "auto", // preserves the minus sign on refund amounts
      }).format(amount);
    } catch (err) {
      const sign = amount < 0 ? "-" : "";
      return sign + (currency || "£") + Math.abs(Number(amount)).toFixed(2);
    }
  }

  function fetchTransaction(id) {
    return authFetch(TRANSACTION_RECEIPT(id), {
      method: "GET",
      orgHeader: false,
    })
      .then(function (res) {
        if (!res.ok || !res.data || !res.data.result) {
          throw new Error("Transaction API responded with " + res.status);
        }
        return res.data.result;
      })
      .catch(function (err) {
        console.warn(
          "[shopping-receipt] Receipt API failed, falling back to the history list:",
          err,
        );
        return findTransactionInHistory(id, 0);
      });
  }

  function findTransactionInHistory(id, offset) {
    return authFetch(
      TRANSACTIONS + "?limit=" + FALLBACK_PAGE_SIZE + "&offset=" + offset,
      { method: "GET" },
    ).then(function (res) {
      if (!res.ok || !res.data) {
        throw new Error("Transactions API responded with " + res.status);
      }

      const items = Array.isArray(res.data.result) ? res.data.result : [];
      const total =
        typeof res.data.totalCount === "number"
          ? res.data.totalCount
          : items.length;

      const found = items.find(function (t) {
        return String(t.id) === String(id);
      });
      if (found) return found;

      const scanned = offset + items.length;
      if (items.length === 0 || scanned >= total) return null;

      return findTransactionInHistory(id, scanned);
    });
  }

  function buildAddressLines(storeInfo) {
    return [
      storeInfo.address1,
      storeInfo.address2,
      storeInfo.city,
      storeInfo.postCode,
    ].filter(function (part) {
      return part && String(part).trim();
    });
  }

  function mapTransaction(raw) {
    const summary = raw.basketSummary || {};
    const store = raw.storeInfo || {};
    const products = (raw.basket && raw.basket.products) || [];
    const totalTaxSummary = (raw.basket && raw.basket.totalTaxSummary) || [];
    const payment = (raw.paymentDetails && raw.paymentDetails[0]) || {};
    const dateIso = raw.dateTime || raw.createdAt;
    const isRefund = raw.type === "REFUND";

    const totalInclVat =
      summary.shippingTotal > 0
        ? summary.basketTotalWithShippingTotal
        : summary.basketTotal;

    const totalExclVat = totalTaxSummary.reduce(function (sum, line) {
      return sum + (line.PreTaxSum || 0);
    }, 0);

    const vatRates = Array.from(
      new Set(
        totalTaxSummary
          .map(function (line) {
            return line.VAT;
          })
          .filter(function (v) {
            return v != null;
          }),
      ),
    );
    const vatRateLabel =
      vatRates.length === 1 ? "VAT at " + vatRates[0] + "%" : "VAT";

    return {
      transactionNumber: raw.transactionId || raw.id,
      isRefund: isRefund,
      dateLabel: formatDate(dateIso),
      timeLabel: formatTime(dateIso),
      totalLabel: formatMoney(totalInclVat, raw.baseCurrency),
      paymentMethod: (() => {
        const method =
          payment.tenderDisplayText ||
          payment.paymentDisplayLabel ||
          payment.paymentType ||
          "";

        if (!method) return "";

        return method.toLowerCase().endsWith("payment")
          ? method
          : method + " payment";
      })(),
      storeName: store.storeName || store.companyName || "",
      addressLines: buildAddressLines(store),
      itemsCountLabel:
        summary.totalItems != null
          ? summary.totalItems + (summary.totalItems === 1 ? " item" : " items")
          : "",
      items: products.map(function (p) {
        const imageUrl =
          Array.isArray(p.imageUrls) &&
          p.imageUrls.find(function (u) {
            return u && u.trim();
          });
        return {
          title: p.description || "",
          price: formatMoney(Math.abs(p.price), raw.baseCurrency),
          quantity: p.quantity,
          imageUrl: imageUrl || null,
        };
      }),
      totalExclVatLabel: formatMoney(totalExclVat, raw.baseCurrency),
      vatRateLabel: vatRateLabel,
      vatAmountLabel: formatMoney(summary.VATTotal, raw.baseCurrency),
      totalInclVatLabel: formatMoney(totalInclVat, raw.baseCurrency),
    };
  }

  // ---- rendering ---------------------------------------------------------

  function setTaxRow(rowEl, label, value) {
    if (!rowEl) return;
    const labelEl = rowEl.querySelector(".receipt-tax-label");
    const valueEl = rowEl.querySelector(".receipt-tax-value");
    if (labelEl) labelEl.textContent = label;
    if (valueEl) valueEl.textContent = value;
  }

  function buildItemCard(item) {
    const card = document.createElement("div");
    card.className = "receipt-item-card";

    const imageWrap = document.createElement("div");
    imageWrap.className = "receipt-item-image";

    function appendPlaceholder() {
      if (!PLACEHOLDER_IMAGE) {
        const placeholder = document.createElement("div");
        placeholder.className = "receipt-item-image-placeholder";
        imageWrap.appendChild(placeholder);
        return;
      }
      const ph = document.createElement("img");
      ph.src = PLACEHOLDER_IMAGE;
      ph.loading = "lazy";
      ph.alt = "Product image unavailable";
      ph.className = "receipt-item-image-placeholder";
      imageWrap.appendChild(ph);
    }

    if (item.imageUrl) {
      const img = document.createElement("img");
      img.src = item.imageUrl;
      img.loading = "lazy";
      img.alt = item.title;
      img.addEventListener("error", function () {
        img.remove();
        appendPlaceholder();
      });
      imageWrap.appendChild(img);
    } else {
      appendPlaceholder();
    }
    card.appendChild(imageWrap);

    const title = document.createElement("p");
    title.className = "receipt-item-title";
    title.textContent = item.title;
    card.appendChild(title);

    const price = document.createElement("p");
    price.className = "receipt-item-price";
    price.textContent = item.price;
    card.appendChild(price);

    if (item.quantity != null) {
      const qty = document.createElement("p");
      qty.className = "receipt-item-meta";
      qty.textContent = "Quantity: " + Math.abs(item.quantity);
      card.appendChild(qty);
    }

    return card;
  }

  function renderReceipt(tx) {
    if (tx.isRefund && els.receiptTitle) {
      els.receiptTitle.textContent = "Refund receipt";
    }

    if (els.breadcrumbCurrent) {
      els.breadcrumbCurrent.textContent =
        tx.dateLabel + " " + tx.transactionNumber;
    }
    if (els.transactionNumber)
      els.transactionNumber.textContent = tx.transactionNumber;
    if (els.copyBtn)
      els.copyBtn.setAttribute("data-copy-value", tx.transactionNumber);

    if (els.summaryDate)
      els.summaryDate.innerHTML = tx.dateLabel + "<br>" + tx.timeLabel;
    if (els.summaryTotal) els.summaryTotal.textContent = tx.totalLabel;
    if (els.summaryPayment) els.summaryPayment.textContent = tx.paymentMethod;

    if (els.storeAddress) {
      els.storeAddress.innerHTML = [tx.storeName]
        .concat(tx.addressLines)
        .join("<br>");
    }

    if (els.itemsHeading) {
      let countEl = els.itemsHeading.querySelector(".receipt-items-count");
      if (!countEl && tx.itemsCountLabel) {
        countEl = document.createElement("span");
        countEl.className = "receipt-items-count";
        els.itemsHeading.appendChild(countEl);
      }
      if (countEl) countEl.textContent = tx.itemsCountLabel;
    }

    if (els.itemsGrid) {
      els.itemsGrid.innerHTML = "";
      tx.items.forEach(function (item) {
        els.itemsGrid.appendChild(buildItemCard(item));
      });
    }

    if (els.taxRows && els.taxRows.length >= 3) {
      setTaxRow(els.taxRows[0], "Total excluding VAT", tx.totalExclVatLabel);
      setTaxRow(els.taxRows[1], tx.vatRateLabel, tx.vatAmountLabel);
      setTaxRow(els.taxRows[2], "Total including VAT", tx.totalInclVatLabel);
    }
  }

  function renderQrCode(raw) {
    const box = root.querySelector("[data-receipt-qr]");
    const code = [raw.storeId, raw.transactionId]
      .filter(function (part) {
        return part && String(part).trim();
      })
      .join("-");
    if (!box || !code || !QRCODE_URL || !window.ReceiptPrint) return;

    window.ReceiptPrint.loadLibrary(QRCODE_URL, "qrcode")
      .then(function (qrcode) {
        const qr = qrcode(0, "M");
        qr.addData(code);
        qr.make();
        box.innerHTML = qr.createSvgTag({ margin: 0, scalable: true });
        box.setAttribute("role", "img");
        box.setAttribute("aria-label", "Receipt QR code " + code);
      })
      .catch(function (err) {
        console.error("[shopping-receipt] Could not render QR code:", err);
      });
  }

  function bindPrintLink(raw) {
    if (!els.printLink || !window.ReceiptPrint) return;
    els.printLink.hidden = false;
    els.printLink.addEventListener("click", function (event) {
      event.preventDefault();
      window.ReceiptPrint.open(raw);
    });
  }

  function showError(message) {
    const container = root.querySelector(".receipt-items-section") || root;
    const wrap = document.createElement("div");
    wrap.style.textAlign = "center";
    wrap.style.padding = "64px 0";

    const errorEl = document.createElement("p");
    errorEl.className = "shopping-history-empty";
    errorEl.textContent = message;
    wrap.appendChild(errorEl);

    const backLink = document.createElement("a");
    backLink.href = HISTORY_PAGE_URL;
    backLink.className = "receipt-action-link link-hover-line";
    backLink.textContent = "Back to shopping history";
    wrap.appendChild(backLink);

    container.prepend(wrap);
  }

  // ---- data loading ---------------------------------------------------------

  if (!transactionId) {
    console.error(
      "[shopping-receipt] No transaction id in the URL (expected ?id=...).",
    );
    showError("We couldn't find that receipt.");
    hideLoader();
    return;
  }

  fetchTransaction(transactionId)
    .then(function (raw) {
      if (!raw) throw new Error("Transaction not found");
      renderReceipt(mapTransaction(raw));
      bindPrintLink(raw);
      renderQrCode(raw);
    })
    .catch(function (err) {
      console.error("[shopping-receipt] Failed to load receipt:", err);
      showError(
        "We couldn't load this receipt right now. Please try again later.",
      );
    })
    .finally(hideLoader);
})();
